var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-empty',{attrs:{"align":"center","image":"error","description":"We're sure you are lost. There is nothing here."}})}
var staticRenderFns = []

export { render, staticRenderFns }